import { useEffect } from "react";
import { getLocalItem, setLocalItem } from "@/lib/commonService";
import { isLogin as checkLogin } from "@/src/models/loginModel";
import { sha256 } from "js-sha256";
import { useUserInfoContext } from "../provider";

interface UseUserAuthenticationFlowProps {
    setLoginState: () => void;
    setLogoutState: () => void;
    totalNum: number;
}

export const useUserAuthenticationFlow = ({
    setLoginState,
    setLogoutState,
    totalNum,
}: UseUserAuthenticationFlowProps) => {
    const [getUserInfo, data] = useUserInfoContext((state) => [
        state.getUserInfo,
        state.data,
    ]);

    // 处理用户信息获取
    useEffect(() => {
        (async () => {
            await getUserInfo();
        })();
    }, [getUserInfo, totalNum]);

    // 处理用户认证流程和数据存储
    useEffect(() => {
        (async () => {
            const isLogin = checkLogin(); // 登录态

            if (!isLogin) {
                setLogoutState();
            } else {
                setLoginState();
            }

            if (isLogin) {
                const customers_email_address =
                    data.customers_email_address || "";

                // 储存邮箱hash值，用于部分广告投放转化
                if (customers_email_address) {
                    setLocalItem(
                        "customers_email_address",
                        sha256(customers_email_address.toLowerCase()),
                    );
                }

                // 处理老用户标记逻辑
                if (data.is_old_customer) {
                    // 根据 customers_id 获取schema接口
                    const is_old_customer = !!data.is_old_customer;
                    // 记录老用户
                    const local_older = getLocalItem("is_old_customer");

                    if (
                        (!local_older ||
                            local_older == "undefined" ||
                            local_older == "false") &&
                        is_old_customer
                    ) {
                        setLocalItem(
                            "is_old_customer",
                            (!!data.is_old_customer).toString(),
                        );
                    }
                } else {
                    getUserInfo();
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, setLoginState, setLogoutState, getUserInfo]);
};
